import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function MariageInvitation() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="max-w-3xl mx-auto p-8 text-center">
        <h1 className="text-6xl font-bold text-black mb-6">
          {t('Digital Mariage Invitation')}
        </h1>
        <h2 className="text-2xl text-black mb-6">
          {t('Digital Mariage Invitation Feature Coming Soon!')}
        </h2>
        <p className="text-xl text-black mb-10">
          {t('We are excited to introduce Digital Mariage Invitation, a new and free way to send your wedding invitation to all of your loved ones. Stay tuned for more updates!')}
        </p>
        <Link
          to="/"
          className="inline-block bg-pink-600 text-white font-semibold py-3 px-8 rounded-full hover:bg-pink-500 transition duration-300"
        >
          {t('Back to Home')}
        </Link>
        <div className="mt-12">
          <p className="text-black">
            {t('Stay updated:')}
          </p>
          <form className="mt-4 flex justify-center">
            <input
              type="email"
              className="px-4 py-2 w-64 text-black border-2 border-pink-600 rounded-l-full focus:outline-none"
              placeholder={t('Enter your email')}
            />
            <button
              type="submit"
              className="bg-pink-600 text-white font-semibold py-2 px-6 rounded-r-full hover:bg-pink-500 transition duration-300"
            >
              {t('Notify Me')}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
